import Vue from 'vue'
import moment from 'moment'

// add moment
Vue.prototype.$moment = moment

declare module 'vue/types/vue' {
  interface Vue {
    $moment: moment.Moment
  }
}
